import { DependencyList, useLayoutEffect } from 'react';

export default function useScrollTop(deps: DependencyList = []) {
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
